import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { companyLinks, getInTouchLinks, legalLinks, servicesLinks } from '../../constants/resource-images';
import { FooterSections } from '../../constants/footer-sections.enum';
import { Store } from '@ngrx/store';
import { basicLayoutActions } from '../../state/actions';
import { Subscription } from 'rxjs';
import { ToastyService } from '@app/shared/services/toasty.service';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {

  @Input() prevSectionColor: string = 'white';
  @Input() footerImages: string[] = [];
  @Input() isSmallScreen!: boolean;

  formGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  activeSection: FooterSections | null = FooterSections.GET_IN_TOUCH;
  companyLinks = companyLinks;
  currentYear: number = new Date().getFullYear();
  errorMessage = '';
  footerSections = FooterSections;
  getInTouchLinks = getInTouchLinks;
  isLoading = false;
  legalLinks = legalLinks;
  servicesLinks = servicesLinks;
  success = false;

  private subscriptions = new Subscription();

  constructor(public store: Store, public actions$: Actions, public toastyService: ToastyService) { }

  ngOnInit(): void {
    const successSub = this.actions$.pipe(
      ofType(basicLayoutActions.subscribeSuccess)
    ).subscribe(() => {
      this.formGroup.reset();
      this.toastyService.success('Thanks for subscribing!');
      this.success = true;
      this.isLoading = false;
    });
    const errorSub = this.actions$.pipe(
      ofType(basicLayoutActions.subscribeFailure)
    ).subscribe(({ error }) => {
      this.errorMessage = error.error.message + ' Please try again.';
      this.isLoading = false;
      this.success = false;
    });
    this.subscriptions.add(successSub);
    this.subscriptions.add(errorSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  subscribe() {
    this.errorMessage = '';
    if (this.formGroup.invalid) {
      return;
    }
    this.isLoading = true;
    this.store.dispatch(basicLayoutActions.sendSubscribe({ email: this.formGroup.value.email!.toString() }));
  }

  toggleSection(section: FooterSections): void {
    this.activeSection = this.activeSection === section ? null : section;
  }
}
